import PutSnippetBase from './put_snippet_base';

export default class CreateSnippet extends PutSnippetBase {
  runAction(attrs) {
    this.context.gateways.snippet.add(attrs);
  }
}
